import { render, staticRenderFns } from "./plazodias.vue?vue&type=template&id=264d0994&scoped=true"
import script from "./plazodias.vue?vue&type=script&lang=js"
export * from "./plazodias.vue?vue&type=script&lang=js"
import style0 from "./plazodias.vue?vue&type=style&index=0&id=264d0994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d0994",
  null
  
)

export default component.exports